module.exports = __webpack_public_path__ + "img/375.034fa17f.jpg";